export const FREEMIUM_LIMITED = 'freemium-limited'
export const SPI_CHECKBOXES = 'spi-checkboxes'
export const FREEMIUM_CREDIBILITY = 'freemium-credibility'
export const DEBUG_MODE = 'debug-mode'
export const NO_ENGAGEMENT_SURVEY = 'no-engagement-survey'
export const FREEMIUM_PRO_MODAL = 'freemium-pro-modal'
export const FREEMIUM_STATUS = 'freemium-status'
export const SIMILAR_CARD = 'similar-card'
export const FREEMIUM_EXIT_POPUP = 'freemium-exit-popup'
export const ACTIVATION_POPUP = 'activation-popup'
export const VIDEO_RECORDER = 'video-recorder'
export const AUTOMATIC_APPLICATION_MODAL = 'automatic-application-modal'
export const ACTIVATION_POPUP_PAID = 'activation-popup-paid'
export const WINNERS_BTN = 'dashboard-header-winners-button'
export const REFERRAL_PROGRAM = 'referral-program'
export const DASHBOARD_APPLICATION_STRATEGY_HEALTH_BAR = 'dashboard-application-strategy-health-bar'
export const LOOP_GUEST_ACCOUNT = 'loop-guest-account'
export const LOOP_TRIAL_EXTENSION = 'loop-trial-extension'
